import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";
import { GET_TRANSACTION_BY_ID } from "../../../graphql/queries/transaction";
import { GoBackIcon } from "../../../../public/assets";
import {
  CreateLinkSubHeader,
  CreateGoback,
} from "../../../pages/CreatePaymentLink/CreatePaymentLink.styles";
import { useNavigate } from "react-router-dom";
import environment from "../../../env";
import { printNested } from "../../../utils/general";

// Styled components
const Container = styled.div`
  padding: 20px;
  background-color: white;
  overflow-y: scroll;
  height: 624px;
  margin-top: 16px;
`;

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
  font-family: GT Walsheim Pro;
  font-size: 26px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #09005b;
`;

const TransactionDetails = styled.div`
  border-radius: 8px;
  padding: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHead = styled.thead`
  background-color: #f2f2f2;
`;

const TableBody = styled.tbody``;

const TableRow = styled.tr``;

const TableHeaderCell = styled.th`
  padding: 10px;
  text-align: left;
  font-size: 16px;
`;

const TableCell = styled.td`
  padding: 10px;
  border-top: 1px solid #ddd;
`;

const LoadingText = styled.p`
  font-size: 16px;
  color: #555;
`;

const ErrorText = styled.p`
  font-size: 16px;
  color: #f00;
`;

const TransactionById = () => {
  const { id } = useParams<{ id: string }>();
  const { loading, error, data } = useQuery(GET_TRANSACTION_BY_ID, {
    variables: {
      ...environment.paymentLinkService,
      getTransactionByIdId: id,
    },
  });
  const navigate = useNavigate();
  const singleTransaction = data?.getTransactionById;

  const NavigateBackTransaction = () => {
    navigate("/dashboard/transaction");
  };
  const transaction = printNested(singleTransaction || {}, [
    "organizationId",
    "id",
  ]);
  return (
    <Container>
      <CreateLinkSubHeader>
        <img
          src="/assets/svg/goBack.svg"
          alt=""
          onClick={NavigateBackTransaction}
        />{" "}
        <CreateGoback>Go back</CreateGoback>
      </CreateLinkSubHeader>
      <Title>Transaction Details</Title>
      <TransactionDetails>
        {loading && <LoadingText>Loading...</LoadingText>}
        {error && <ErrorText>Error: {error.message}</ErrorText>}
        {singleTransaction && (
          <Table>
            <TableHead>
              <TableRow>
                <TableHeaderCell></TableHeaderCell>
                <TableHeaderCell></TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transaction &&
                transaction?.map(({ label, value }) => (
                  <TableRow>
                    <TableHeaderCell>{label}</TableHeaderCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TransactionDetails>
    </Container>
  );
};

export default TransactionById;
